import { on } from '../modules/_fn';

/* ---------------------------------------- swiper */
function buildSwiperCarousel(swiperTarget) {
	if ($(swiperTarget)) {
		var swiperConfig = {
			speed: 300,
			initialSlide: 0,
			slidesPerView: 'auto',
			spaceBetween: 8,
			centeredSlides: true,
			watchSlidesProgress: true,
			pagination: {
				el: swiperTarget + ' .swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
			navigation: {
				nextEl: swiperTarget + ' .swiper-button-next',
				prevEl: swiperTarget + ' .swiper-button-prev',
			},
			breakpoints: {
				640: {
					initialSlide: 1,
					slidesPerView: 'auto',
					spaceBetween: 20,
				},
				1024: {
					initialSlide: 1,
					slidesPerView: 3,
					spaceBetween: 20,
				},
			},
		};

		if (typeof Swiper !== undefined) {
			new Swiper(swiperTarget + ' .swiper-container', swiperConfig);
		}
	}
}

on(window, 'load', buildSwiperCarousel('.sec-adult'));
/* ---------------------------------------- swiper */


/* ---------------------------------------- adult */
const btnName = {
	'submit': '.js-adult-submit',
	'ban': '.js-adult-ban',
	'allow': '.js-adult-allow'
}

const adultName = {
	'agreement': '.adult-agreement',
	'cover': '.adult-cover',
}

$(document).on('click', btnName['submit'], function() {
	$(adultName['agreement']).removeClass('is-active');
	$(adultName['agreement']+'[data-step="2"]').addClass('is-active');
});

$(document).on('click', btnName['ban'], function() {
	$(adultName['agreement']).removeClass('is-active');
	$(adultName['agreement']+'[data-step="1"]').addClass('is-active');
});

$(document).on('click', btnName['allow'], function() {
	$(adultName['agreement']).removeClass('is-active');
	$(adultName['cover']).removeClass('is-not-allow');
});